import type { LDOptions } from "launchdarkly-react-client-sdk";

export function getLaunchDarklyProxyOptions(proxyUrl: string): LDOptions {
    const url = proxyUrl.trim().replace(/\/+$/, "");

    if (!url) {
        return {};
    }

    return { baseUrl: url, streamUrl: url, eventsUrl: url };
}
